import React from 'react';


const Risk: React.FC<{ module: string }> = ({module}) => {


  return (
    <div style={{width: 1294, height: 550}}>
      <div>Risk</div>
    </div>
  );
}


export default Risk;
